// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ps-page {
  --bg: #F1EFE8;
  --surface: #FFFFFF;
  --surface-2: #FAF9F5;
  --ink: #2C2C2A;
  --ink-2: #57544D;
  --ink-3: #888780;
  --line: #E5E2D9;
  --line-2: #C9C5B8;
  --info-bg: #E6F1FB;
  --info: #185FA5;
  --info-line: #B8D5EE;
  --ok-bg: #EAF3DE;
  --ok: #3B6D11;
  --ok-line: #97C459;
  --warn-bg: #FAEEDA;
  --warn: #854F0B;
  --warn-line: #EF9F27;
  --bad-bg: #FBEAF0;
  --bad: #993556;
  --bad-line: #ED93B1;
  --purple-bg: #EEEDFE;
  --purple: #3C3489;
  --purple-line: #AFA9EC;
  --r: 10px;
  --r-sm: 7px;
  --r-lg: 14px;
  --font: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  --mono: "SF Mono", Monaco, Consolas, monospace;

  min-height: 100vh;
  font-family: var(--font);
  font-size: 13px;
  line-height: 1.45;
  color: var(--ink);
  background: var(--bg);
  -webkit-font-smoothing: antialiased;
  padding-top: 50px;
}

.ps-page .tnum { font-variant-numeric: tabular-nums; }
.ps-page .truncate { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

.ps-page-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 12px 18px 0;
  max-width: 920px;
  margin: 0 auto;
}

.ps-page-btn {
  padding: 7px 12px;
  border: 1px solid var(--line);
  background: var(--surface);
  border-radius: var(--r-sm);
  font-size: 12px;
  color: var(--ink-2);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  text-decoration: none;
  font-family: inherit;
}

.ps-page-btn:hover { border-color: var(--line-2); }

.ps-wrap { max-width: 920px; margin: 0 auto; padding: 12px 18px 40px; }

.ps-tabs {
  display: flex;
  gap: 4px;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r);
  padding: 4px;
  margin-bottom: 16px;
}

.ps-tab {
  flex: 1 1;
  padding: 9px;
  text-align: center;
  border-radius: var(--r-sm);
  font-size: 13px;
  color: var(--ink-2);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: none;
  background: transparent;
  font-family: inherit;
}

.ps-tab.active { background: var(--ink); color: #fff; font-weight: 500; }
.ps-tab i { font-size: 16px; }

.ps-panel {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  overflow: hidden;
  margin-bottom: 14px;
}

.ps-panel-head { padding: 13px 16px; border-bottom: 1px solid var(--line); }
.ps-panel-title { font-size: 13px; font-weight: 500; display: flex; align-items: center; gap: 7px; }
.ps-panel-sub { font-size: 11px; color: var(--ink-3); margin-top: 2px; }
.ps-panel-body { padding: 16px; }

.ps-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 0;
  border-bottom: 1px solid var(--line);
  gap: 12px;
  flex-wrap: wrap;
}

.ps-row:last-child { border-bottom: none; }
.ps-row-label { font-size: 13px; }
.ps-row-sub { font-size: 11px; color: var(--ink-3); margin-top: 1px; }

.ps-num-input {
  width: 64px;
  padding: 7px 9px;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  font-size: 13px;
  font-family: inherit;
  text-align: center;
  outline: none;
  background: var(--surface-2);
}

.ps-num-input:focus { border-color: var(--info-line); background: var(--surface); }

.ps-text-input {
  width: 220px;
  padding: 8px 10px;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  font-size: 13px;
  font-family: inherit;
  outline: none;
  background: var(--surface-2);
}

.ps-text-input:focus { border-color: var(--info-line); background: var(--surface); }

.ps-channels { display: flex; gap: 7px; flex-wrap: wrap; }

.ps-ch-pill {
  padding: 7px 13px;
  border: 1px solid var(--line);
  border-radius: 16px;
  font-size: 12px;
  color: var(--ink-2);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  -webkit-user-select: none;
          user-select: none;
  background: none;
  font-family: inherit;
}

.ps-ch-pill.on {
  background: var(--info-bg);
  border-color: var(--info-line);
  color: var(--info);
  font-weight: 500;
}

.ps-btn {
  padding: 10px 16px;
  border: none;
  border-radius: var(--r-sm);
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.ps-btn.primary { background: var(--ink); color: #fff; }
.ps-btn.ghost { background: transparent; border: 1px solid var(--line); color: var(--ink-2); }
.ps-btn.sm { padding: 6px 11px; font-size: 12px; }

.ps-acc-row {
  display: grid;
  grid-template-columns: 1.6fr repeat(4, 0.7fr) 0.5fr;
  gap: 8px;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid var(--line);
}

.ps-acc-head {
  background: var(--surface-2);
  font-size: 9px;
  letter-spacing: 0.4px;
  color: var(--ink-3);
  font-weight: 500;
  text-transform: uppercase;
  border-bottom: 1px solid var(--line);
}

.ps-acc-row:last-child { border-bottom: none; }
.ps-acc-name { font-size: 13px; font-weight: 500; }
.ps-acc-role { font-size: 10px; color: var(--ink-3); }

.ps-perm-check {
  width: 34px;
  height: 20px;
  border-radius: 10px;
  background: var(--line-2);
  position: relative;
  cursor: pointer;
  transition: background 0.15s;
  margin: 0 auto;
}

.ps-perm-check::after {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  top: 2px;
  left: 2px;
  transition: left 0.15s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.ps-perm-check.on { background: var(--ok); }
.ps-perm-check.on::after { left: 16px; }
.ps-perm-check.locked { opacity: 0.4; cursor: not-allowed; }

.ps-owner-badge {
  font-size: 9px;
  background: var(--purple-bg);
  color: var(--purple);
  padding: 2px 7px;
  border-radius: 7px;
  margin-left: 4px;
}

.ps-filters { display: flex; gap: 7px; margin-bottom: 12px; flex-wrap: wrap; }

.ps-sel {
  padding: 7px 10px;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  font-size: 12px;
  font-family: inherit;
  background: var(--surface-2);
  color: var(--ink-2);
  outline: none;
  cursor: pointer;
}

.ps-hist-row {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  gap: 10px;
  align-items: center;
  padding: 9px 12px;
  border-bottom: 1px solid var(--line);
  font-size: 12px;
}

.ps-hist-row:last-child { border-bottom: none; }

.ps-rk {
  font-size: 9px;
  padding: 2px 6px;
  border-radius: 6px;
  font-weight: 500;
  text-transform: capitalize;
}

.ps-rk.retailer { background: var(--info-bg); color: var(--info); }
.ps-rk.salesman { background: var(--purple-bg); color: var(--purple); }

.ps-st {
  font-size: 10px;
  padding: 2px 7px;
  border-radius: 7px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  text-transform: capitalize;
}

.ps-st.delivered,
.ps-st.read,
.ps-st.sent { background: var(--ok-bg); color: var(--ok); }
.ps-st.queued { background: var(--warn-bg); color: var(--warn); }
.ps-st.failed,
.ps-st.bounced { background: var(--bad-bg); color: var(--bad); }
.ps-st.clicked { background: var(--purple-bg); color: var(--purple); }
.ps-st.payment_received,
.ps-st.paid { background: var(--ok-bg); color: var(--ok); }

.ps-audit-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--line);
}

.ps-audit-row:last-child { border-bottom: none; }

.ps-audit-dot {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ps-audit-dot i { font-size: 14px; }
.ps-a-add { background: var(--ok-bg); color: var(--ok); }
.ps-a-remove { background: var(--bad-bg); color: var(--bad); }
.ps-a-settings { background: var(--info-bg); color: var(--info); }
.ps-a-access { background: var(--purple-bg); color: var(--purple); }

.ps-audit-main { flex: 1 1; min-width: 0; }
.ps-audit-text { font-size: 12px; }
.ps-audit-actor { font-weight: 500; }
.ps-audit-time { font-size: 10px; color: var(--ink-3); white-space: nowrap; }

.ps-empty { text-align: center; padding: 30px; color: var(--ink-3); }
.ps-empty i { font-size: 32px; color: var(--line-2); display: block; margin-bottom: 8px; }

.ps-save-bar { display: flex; justify-content: flex-end; gap: 8px; padding-top: 6px; }

.ps-perm-note {
  display: flex;
  gap: 7px;
  align-items: flex-start;
  background: var(--info-bg);
  border: 1px solid var(--info-line);
  border-radius: var(--r-sm);
  padding: 10px 12px;
  font-size: 11px;
  color: #0E3F6E;
  margin-top: 12px;
}

.ps-perm-note i { font-size: 14px; flex-shrink: 0; margin-top: 1px; }

.ps-spinner {
  width: 24px;
  height: 24px;
  border: 3px solid var(--line);
  border-top-color: var(--info);
  border-radius: 50%;
  animation: ps-spin 0.7s linear infinite;
  margin: 24px auto;
}

@keyframes ps-spin { to { transform: rotate(360deg); } }

.ps-toast-wrap {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 80;
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
}

.ps-toast {
  background: var(--ink);
  color: #fff;
  padding: 10px 16px;
  border-radius: var(--r-sm);
  font-size: 12px;
  display: flex;
  gap: 8px;
  align-items: center;
}

.ps-toast.bad { background: var(--bad); }

.ps-revoke-icon {
  color: var(--ink-3);
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  font-size: 16px;
}

.ps-revoke-icon:hover { color: var(--bad); }

.ps-grant-row {
  margin-top: 16px;
}

.ps-grant-label {
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 13px;
}

.ps-grant-flex {
  display: flex;
  gap: 8px;
}

.ps-grant-flex .ps-sel { flex: 1 1; }

@media (max-width: 720px) {
  .ps-acc-row,
  .ps-acc-head {
    grid-template-columns: 1fr;
    gap: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Css/PaymentSettings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kGAAkG;EAClG,8CAA8C;;EAE9C,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA,iBAAiB,kCAAkC,EAAE;AACrD,qBAAqB,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;;AAErF;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,qBAAqB,2BAA2B,EAAE;;AAElD,WAAW,gBAAgB,EAAE,cAAc,EAAE,uBAAuB,EAAE;;AAEtE;EACE,aAAa;EACb,QAAQ;EACR,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,iBAAiB,sBAAsB,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACxE,YAAY,eAAe,EAAE;;AAE7B;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iBAAiB,kBAAkB,EAAE,oCAAoC,EAAE;AAC3E,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACnG,gBAAgB,eAAe,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACvE,iBAAiB,aAAa,EAAE;;AAEhC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,oCAAoC;EACpC,SAAS;EACT,eAAe;AACjB;;AAEA,qBAAqB,mBAAmB,EAAE;AAC1C,gBAAgB,eAAe,EAAE;AACjC,cAAc,eAAe,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAErE;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B;;AAEA,sBAAsB,8BAA8B,EAAE,0BAA0B,EAAE;;AAElF;EACE,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,4BAA4B;AAC9B;;AAEA,uBAAuB,8BAA8B,EAAE,0BAA0B,EAAE;;AAEnF,eAAe,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;;AAEzD;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,kBAAkB,sBAAsB,EAAE,WAAW,EAAE;AACvD,gBAAgB,uBAAuB,EAAE,6BAA6B,EAAE,mBAAmB,EAAE;AAC7F,aAAa,iBAAiB,EAAE,eAAe,EAAE;;AAEjD;EACE,aAAa;EACb,mDAAmD;EACnD,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,yBAAyB,mBAAmB,EAAE;AAC9C,eAAe,eAAe,EAAE,gBAAgB,EAAE;AAClD,eAAe,eAAe,EAAE,mBAAmB,EAAE;;AAErD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA,oBAAoB,qBAAqB,EAAE;AAC3C,2BAA2B,UAAU,EAAE;AACvC,wBAAwB,YAAY,EAAE,mBAAmB,EAAE;;AAE3D;EACE,cAAc;EACd,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,cAAc,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAE7E;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,oCAAoC;EACpC,eAAe;AACjB;;AAEA,0BAA0B,mBAAmB,EAAE;;AAE/C;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,kBAAkB,0BAA0B,EAAE,kBAAkB,EAAE;AAClE,kBAAkB,4BAA4B,EAAE,oBAAoB,EAAE;;AAEtE;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;;cAEc,wBAAwB,EAAE,gBAAgB,EAAE;AAC1D,gBAAgB,0BAA0B,EAAE,kBAAkB,EAAE;AAChE;iBACiB,yBAAyB,EAAE,iBAAiB,EAAE;AAC/D,iBAAiB,4BAA4B,EAAE,oBAAoB,EAAE;AACrE;cACc,wBAAwB,EAAE,gBAAgB,EAAE;;AAE1D;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,kBAAkB,eAAe,EAAE;AACnC,YAAY,wBAAwB,EAAE,gBAAgB,EAAE;AACxD,eAAe,yBAAyB,EAAE,iBAAiB,EAAE;AAC7D,iBAAiB,0BAA0B,EAAE,kBAAkB,EAAE;AACjE,eAAe,4BAA4B,EAAE,oBAAoB,EAAE;;AAEnE,iBAAiB,SAAO,EAAE,YAAY,EAAE;AACxC,iBAAiB,eAAe,EAAE;AAClC,kBAAkB,gBAAgB,EAAE;AACpC,iBAAiB,eAAe,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;;AAE5E,YAAY,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACpE,cAAc,eAAe,EAAE,oBAAoB,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAEzF,eAAe,aAAa,EAAE,yBAAyB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;;AAErF;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,0BAA0B;EAC1B,kCAAkC;EAClC,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEpE;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;EAClB,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA,gBAAgB,sBAAsB,EAAE;;AAExC;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA,wBAAwB,iBAAiB,EAAE;;AAE3C;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,yBAAyB,SAAO,EAAE;;AAElC;EACE;;IAEE,0BAA0B;IAC1B,QAAQ;EACV;AACF","sourcesContent":[".ps-page {\r\n  --bg: #F1EFE8;\r\n  --surface: #FFFFFF;\r\n  --surface-2: #FAF9F5;\r\n  --ink: #2C2C2A;\r\n  --ink-2: #57544D;\r\n  --ink-3: #888780;\r\n  --line: #E5E2D9;\r\n  --line-2: #C9C5B8;\r\n  --info-bg: #E6F1FB;\r\n  --info: #185FA5;\r\n  --info-line: #B8D5EE;\r\n  --ok-bg: #EAF3DE;\r\n  --ok: #3B6D11;\r\n  --ok-line: #97C459;\r\n  --warn-bg: #FAEEDA;\r\n  --warn: #854F0B;\r\n  --warn-line: #EF9F27;\r\n  --bad-bg: #FBEAF0;\r\n  --bad: #993556;\r\n  --bad-line: #ED93B1;\r\n  --purple-bg: #EEEDFE;\r\n  --purple: #3C3489;\r\n  --purple-line: #AFA9EC;\r\n  --r: 10px;\r\n  --r-sm: 7px;\r\n  --r-lg: 14px;\r\n  --font: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\r\n  --mono: \"SF Mono\", Monaco, Consolas, monospace;\r\n\r\n  min-height: 100vh;\r\n  font-family: var(--font);\r\n  font-size: 13px;\r\n  line-height: 1.45;\r\n  color: var(--ink);\r\n  background: var(--bg);\r\n  -webkit-font-smoothing: antialiased;\r\n  padding-top: 50px;\r\n}\r\n\r\n.ps-page .tnum { font-variant-numeric: tabular-nums; }\r\n.ps-page .truncate { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\r\n\r\n.ps-page-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 12px 18px 0;\r\n  max-width: 920px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.ps-page-btn {\r\n  padding: 7px 12px;\r\n  border: 1px solid var(--line);\r\n  background: var(--surface);\r\n  border-radius: var(--r-sm);\r\n  font-size: 12px;\r\n  color: var(--ink-2);\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  text-decoration: none;\r\n  font-family: inherit;\r\n}\r\n\r\n.ps-page-btn:hover { border-color: var(--line-2); }\r\n\r\n.ps-wrap { max-width: 920px; margin: 0 auto; padding: 12px 18px 40px; }\r\n\r\n.ps-tabs {\r\n  display: flex;\r\n  gap: 4px;\r\n  background: var(--surface);\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r);\r\n  padding: 4px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.ps-tab {\r\n  flex: 1;\r\n  padding: 9px;\r\n  text-align: center;\r\n  border-radius: var(--r-sm);\r\n  font-size: 13px;\r\n  color: var(--ink-2);\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  border: none;\r\n  background: transparent;\r\n  font-family: inherit;\r\n}\r\n\r\n.ps-tab.active { background: var(--ink); color: #fff; font-weight: 500; }\r\n.ps-tab i { font-size: 16px; }\r\n\r\n.ps-panel {\r\n  background: var(--surface);\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r-lg);\r\n  overflow: hidden;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.ps-panel-head { padding: 13px 16px; border-bottom: 1px solid var(--line); }\r\n.ps-panel-title { font-size: 13px; font-weight: 500; display: flex; align-items: center; gap: 7px; }\r\n.ps-panel-sub { font-size: 11px; color: var(--ink-3); margin-top: 2px; }\r\n.ps-panel-body { padding: 16px; }\r\n\r\n.ps-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 11px 0;\r\n  border-bottom: 1px solid var(--line);\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.ps-row:last-child { border-bottom: none; }\r\n.ps-row-label { font-size: 13px; }\r\n.ps-row-sub { font-size: 11px; color: var(--ink-3); margin-top: 1px; }\r\n\r\n.ps-num-input {\r\n  width: 64px;\r\n  padding: 7px 9px;\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r-sm);\r\n  font-size: 13px;\r\n  font-family: inherit;\r\n  text-align: center;\r\n  outline: none;\r\n  background: var(--surface-2);\r\n}\r\n\r\n.ps-num-input:focus { border-color: var(--info-line); background: var(--surface); }\r\n\r\n.ps-text-input {\r\n  width: 220px;\r\n  padding: 8px 10px;\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r-sm);\r\n  font-size: 13px;\r\n  font-family: inherit;\r\n  outline: none;\r\n  background: var(--surface-2);\r\n}\r\n\r\n.ps-text-input:focus { border-color: var(--info-line); background: var(--surface); }\r\n\r\n.ps-channels { display: flex; gap: 7px; flex-wrap: wrap; }\r\n\r\n.ps-ch-pill {\r\n  padding: 7px 13px;\r\n  border: 1px solid var(--line);\r\n  border-radius: 16px;\r\n  font-size: 12px;\r\n  color: var(--ink-2);\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  user-select: none;\r\n  background: none;\r\n  font-family: inherit;\r\n}\r\n\r\n.ps-ch-pill.on {\r\n  background: var(--info-bg);\r\n  border-color: var(--info-line);\r\n  color: var(--info);\r\n  font-weight: 500;\r\n}\r\n\r\n.ps-btn {\r\n  padding: 10px 16px;\r\n  border: none;\r\n  border-radius: var(--r-sm);\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  font-family: inherit;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.ps-btn.primary { background: var(--ink); color: #fff; }\r\n.ps-btn.ghost { background: transparent; border: 1px solid var(--line); color: var(--ink-2); }\r\n.ps-btn.sm { padding: 6px 11px; font-size: 12px; }\r\n\r\n.ps-acc-row {\r\n  display: grid;\r\n  grid-template-columns: 1.6fr repeat(4, 0.7fr) 0.5fr;\r\n  gap: 8px;\r\n  align-items: center;\r\n  padding: 10px 12px;\r\n  border-bottom: 1px solid var(--line);\r\n}\r\n\r\n.ps-acc-head {\r\n  background: var(--surface-2);\r\n  font-size: 9px;\r\n  letter-spacing: 0.4px;\r\n  color: var(--ink-3);\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n  border-bottom: 1px solid var(--line);\r\n}\r\n\r\n.ps-acc-row:last-child { border-bottom: none; }\r\n.ps-acc-name { font-size: 13px; font-weight: 500; }\r\n.ps-acc-role { font-size: 10px; color: var(--ink-3); }\r\n\r\n.ps-perm-check {\r\n  width: 34px;\r\n  height: 20px;\r\n  border-radius: 10px;\r\n  background: var(--line-2);\r\n  position: relative;\r\n  cursor: pointer;\r\n  transition: background 0.15s;\r\n  margin: 0 auto;\r\n}\r\n\r\n.ps-perm-check::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 50%;\r\n  background: #fff;\r\n  top: 2px;\r\n  left: 2px;\r\n  transition: left 0.15s;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.ps-perm-check.on { background: var(--ok); }\r\n.ps-perm-check.on::after { left: 16px; }\r\n.ps-perm-check.locked { opacity: 0.4; cursor: not-allowed; }\r\n\r\n.ps-owner-badge {\r\n  font-size: 9px;\r\n  background: var(--purple-bg);\r\n  color: var(--purple);\r\n  padding: 2px 7px;\r\n  border-radius: 7px;\r\n  margin-left: 4px;\r\n}\r\n\r\n.ps-filters { display: flex; gap: 7px; margin-bottom: 12px; flex-wrap: wrap; }\r\n\r\n.ps-sel {\r\n  padding: 7px 10px;\r\n  border: 1px solid var(--line);\r\n  border-radius: var(--r-sm);\r\n  font-size: 12px;\r\n  font-family: inherit;\r\n  background: var(--surface-2);\r\n  color: var(--ink-2);\r\n  outline: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.ps-hist-row {\r\n  display: grid;\r\n  grid-template-columns: auto 1fr auto auto;\r\n  gap: 10px;\r\n  align-items: center;\r\n  padding: 9px 12px;\r\n  border-bottom: 1px solid var(--line);\r\n  font-size: 12px;\r\n}\r\n\r\n.ps-hist-row:last-child { border-bottom: none; }\r\n\r\n.ps-rk {\r\n  font-size: 9px;\r\n  padding: 2px 6px;\r\n  border-radius: 6px;\r\n  font-weight: 500;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.ps-rk.retailer { background: var(--info-bg); color: var(--info); }\r\n.ps-rk.salesman { background: var(--purple-bg); color: var(--purple); }\r\n\r\n.ps-st {\r\n  font-size: 10px;\r\n  padding: 2px 7px;\r\n  border-radius: 7px;\r\n  font-weight: 500;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 3px;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.ps-st.delivered,\r\n.ps-st.read,\r\n.ps-st.sent { background: var(--ok-bg); color: var(--ok); }\r\n.ps-st.queued { background: var(--warn-bg); color: var(--warn); }\r\n.ps-st.failed,\r\n.ps-st.bounced { background: var(--bad-bg); color: var(--bad); }\r\n.ps-st.clicked { background: var(--purple-bg); color: var(--purple); }\r\n.ps-st.payment_received,\r\n.ps-st.paid { background: var(--ok-bg); color: var(--ok); }\r\n\r\n.ps-audit-row {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  padding: 10px 12px;\r\n  border-bottom: 1px solid var(--line);\r\n}\r\n\r\n.ps-audit-row:last-child { border-bottom: none; }\r\n\r\n.ps-audit-dot {\r\n  width: 26px;\r\n  height: 26px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.ps-audit-dot i { font-size: 14px; }\r\n.ps-a-add { background: var(--ok-bg); color: var(--ok); }\r\n.ps-a-remove { background: var(--bad-bg); color: var(--bad); }\r\n.ps-a-settings { background: var(--info-bg); color: var(--info); }\r\n.ps-a-access { background: var(--purple-bg); color: var(--purple); }\r\n\r\n.ps-audit-main { flex: 1; min-width: 0; }\r\n.ps-audit-text { font-size: 12px; }\r\n.ps-audit-actor { font-weight: 500; }\r\n.ps-audit-time { font-size: 10px; color: var(--ink-3); white-space: nowrap; }\r\n\r\n.ps-empty { text-align: center; padding: 30px; color: var(--ink-3); }\r\n.ps-empty i { font-size: 32px; color: var(--line-2); display: block; margin-bottom: 8px; }\r\n\r\n.ps-save-bar { display: flex; justify-content: flex-end; gap: 8px; padding-top: 6px; }\r\n\r\n.ps-perm-note {\r\n  display: flex;\r\n  gap: 7px;\r\n  align-items: flex-start;\r\n  background: var(--info-bg);\r\n  border: 1px solid var(--info-line);\r\n  border-radius: var(--r-sm);\r\n  padding: 10px 12px;\r\n  font-size: 11px;\r\n  color: #0E3F6E;\r\n  margin-top: 12px;\r\n}\r\n\r\n.ps-perm-note i { font-size: 14px; flex-shrink: 0; margin-top: 1px; }\r\n\r\n.ps-spinner {\r\n  width: 24px;\r\n  height: 24px;\r\n  border: 3px solid var(--line);\r\n  border-top-color: var(--info);\r\n  border-radius: 50%;\r\n  animation: ps-spin 0.7s linear infinite;\r\n  margin: 24px auto;\r\n}\r\n\r\n@keyframes ps-spin { to { transform: rotate(360deg); } }\r\n\r\n.ps-toast-wrap {\r\n  position: fixed;\r\n  bottom: 20px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 80;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  align-items: center;\r\n}\r\n\r\n.ps-toast {\r\n  background: var(--ink);\r\n  color: #fff;\r\n  padding: 10px 16px;\r\n  border-radius: var(--r-sm);\r\n  font-size: 12px;\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n}\r\n\r\n.ps-toast.bad { background: var(--bad); }\r\n\r\n.ps-revoke-icon {\r\n  color: var(--ink-3);\r\n  cursor: pointer;\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  font-size: 16px;\r\n}\r\n\r\n.ps-revoke-icon:hover { color: var(--bad); }\r\n\r\n.ps-grant-row {\r\n  margin-top: 16px;\r\n}\r\n\r\n.ps-grant-label {\r\n  margin-bottom: 8px;\r\n  font-weight: 500;\r\n  font-size: 13px;\r\n}\r\n\r\n.ps-grant-flex {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.ps-grant-flex .ps-sel { flex: 1; }\r\n\r\n@media (max-width: 720px) {\r\n  .ps-acc-row,\r\n  .ps-acc-head {\r\n    grid-template-columns: 1fr;\r\n    gap: 4px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
